import createAPIRequestId from '../helpers/createAPIRequestId'
import hasTempId from '../helpers/hasTempId'
import store from '../store/index'
//------------------------------
// edit character campaign note
//------------------------------
export default async function useEditCharacterCampaignNote(campaign_note, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterCampaignNote....')
  console.log('campaign note:', campaign_note)
  //--------------
  // access store
  //--------------
  const this_store = store
  //--------------------
  // set api call parms
  //--------------------
  let parm_id = ''
  let parm_partialInd = false
  const hasPersistedId = campaign_note.id != null && campaign_note.id !== '' && !hasTempId(campaign_note.id)

  if (hasPersistedId) {
    parm_id = campaign_note.id
    parm_partialInd = campaign_note.action !== 'DELETE' ? true : false
  }
  //---------------------------------------------
  // declare request parms to create api request
  //--------------------------------------------
  let endpoint = 'api/v1/character-campaign-notes/'
  //
  let request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }
  //---------------------------------------------------
  // where DELETE add indicator for create api request
  //---------------------------------------------------
  if (campaign_note.action === 'DELETE') {
    request_parms.deleteInd = true
  }
  //--------------------------
  // create api request by id
  //--------------------------
  let request = createAPIRequestId(request_parms)
  //---------------
  // set api parms
  //---------------
  let api_parms = {
    api_request: request,
    api_preview: preview,
  }
  //----------------------------------
  // include payload where not DELETE
  //----------------------------------
  if (campaign_note.action !== 'DELETE') {
    api_parms.payload = campaign_note.payload
  }
  console.log('api_parms = ', api_parms)
  //-------------------------------------------------------------------------
  // - return the dispatch Promise in all cases
  // - preview callers will await this and receive the response
  // - non-preview callers can ignore the returned Promise (fire-and-forget)
  //-------------------------------------------------------------------------
  return this_store
    .dispatch('characters/editCharacterCampaignNote', api_parms)
    .then((res) => {
      // optional: log preview response
      if (preview) console.log('useEditCharacterCampaignNote preview result:', res)
      return res
    })
    .catch((err) => {
      console.error('editCharacterCampaignNote error:', err)
      // rethrow so callers awaiting this will receive the rejection
      throw err
    })
}
